import { RouteObject } from "react-router-dom";
import { Templates } from "./components/landing/templates";
export interface TemplatesSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: TemplatesSetupRoute[];
}
export const templatesSetupRoutes: TemplatesSetupRoute[] = [
  {
    path: "/communication-hub/templates",
    element: <Templates />,
  },
];
